/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ create: NonNullable<unknown>, update: NonNullable<unknown>, conflict: NonNullable<unknown>, unchanged: NonNullable<unknown> }} Jobs_Result_PreviewInputs */

const cs_jobs_result_preview = /** @type {(inputs: Jobs_Result_PreviewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.create} nové · ~${i?.update} změny · ⚠${i?.conflict} konflikty · ${i?.unchanged} beze změny`)
};

const en_jobs_result_preview = /** @type {(inputs: Jobs_Result_PreviewInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.create} new · ~${i?.update} changes · ⚠${i?.conflict} conflicts · ${i?.unchanged} unchanged`)
};

/**
* | output |
* | --- |
* | "+{create} new · ~{update} changes · ⚠{conflict} conflicts · {unchanged} unchanged" |
*
* @param {Jobs_Result_PreviewInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const jobs_result_preview = /** @type {((inputs: Jobs_Result_PreviewInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Result_PreviewInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_result_preview(inputs)
	return cs_jobs_result_preview(inputs)
});